export default __webpack_public_path__ + "static/media/signInPhone.51f161ff.png";